// extracted by mini-css-extract-plugin
export default {"mainContainer":"BlogDetails_mainContainer__DZW5F","container":"BlogDetails_container__8hVCX"};